<input
	#poInput
	type="file"
	accept=".pdf,image/*"
	hidden
	(change)="onPurchaseOrderSelected($event)"
	(click)="$event.stopPropagation()" />

<div class="common">
	<label>Order Date
		<input type="date" [value]="orderDate" (change)="orderDate = $any($event.target).value">
	</label>
	<label>Quantity
		<input type="number" min="0" [value]="quantity ?? ''" (change)="onQuantity($any($event.target).value)">
	</label>
	<label>Expected Date
		<input type="date" [value]="expectedDate" (change)="expectedDate = $any($event.target).value">
	</label>
	<label>Initials
		<input [value]="initials" (change)="initials = ($any($event.target).value || '').toUpperCase()">
	</label>
</div>

<div class="choice-title">Choose whichever entry method fits the moment. Both create the same stock-order batch.</div>

<div class="paths">
	<section class="path">
		<div class="path-head"><b>QUANTITY ONLY</b><span>Fastest</span></div>
		<div class="path-body">
			<div class="qty">
				<label>Frames Ordered
					<input type="number" min="0" [value]="framesOrdered ?? ''" (change)="onFramesOrdered($any($event.target).value)">
				</label>
				<label>Planned Returns
					<input type="number" min="0" [value]="plannedReturns ?? ''" (change)="onPlannedReturns($any($event.target).value)">
				</label>
			</div>
			<div class="hint">Save the promise now. Add exact model, color, size, and type when the frames and invoice arrive. An order-sheet photo is optional.</div>
		</div>
	</section>
	<div class="or">or</div>
	<section class="path">
		<div class="path-head"><b>SELECT FROM VENDOR CATALOG</b><span>When catalog exists</span></div>
		<div class="path-body">
			<div class="catalog-tools">
				<input aria-label="Search vendor catalog" placeholder="Search model, color, size" [value]="search" (input)="search = $any($event.target).value">
				<button type="button" (click)="addSelected()">Add Selected</button>
			</div>
			<div class="catalog-list">
				<div class="catalog-row head"><span></span><span>Model</span><span>Color</span><span>Size</span></div>
				<div class="catalog-empty" *ngIf="catalogLoading">Loading catalog…</div>
				<div class="catalog-empty" *ngIf="!catalogLoading && !catalog.length">No catalog for this vendor yet. Use quantity only.</div>
				<label class="catalog-row" *ngFor="let row of visibleCatalog; trackBy: trackRow">
					<input type="checkbox" [checked]="isChecked(row)" (change)="toggleRow(row, $any($event.target).checked)">
					<span>{{ row.model }}</span>
					<span>{{ row.color }}</span>
					<span>{{ row.size }}</span>
				</label>
			</div>
			<div class="hint" *ngIf="catalogMatchCount > visibleCatalog.length">Showing {{ visibleCatalog.length }} of {{ catalogMatchCount }}. Refine the search.</div>
			<div class="hint" *ngIf="added.length">{{ added.length }} catalog frame{{ added.length === 1 ? '' : 's' }} will be saved as this stock order.</div>
		</div>
	</section>
</div>

<footer class="actions">
	<button class="primary" type="button" [disabled]="saving" (click)="save()">Save Stock Order</button>
</footer>
